/**
 * Lead Details Tour Configuration
 * Introduces users to individual lead detail page features
 */

import { TourDefinition } from './tour.types';

export const leadDetailsTour: TourDefinition = {
  id: 'lead-details-tour',
  name: 'Lead Details',
  page: '/leads/', // Matches /leads/[id] pattern
  version: 1,
  steps: [
    {
      id: 'lead-header',
      targetSelector: '[data-tour="lead-details-header"]',
      title: 'Lead Information',
      description:
        'This header shows the lead\'s name, status, and key details at a glance. Use the status dropdown to update the lead\'s progression through your sales pipeline.',
      placement: 'bottom',
    },
    {
      id: 'lead-actions',
      targetSelector: '[data-tour="lead-actions"]',
      title: 'Quick Actions',
      description:
        'Take immediate action on this lead: make a call, send an SMS, schedule an appointment, or set a reminder. These buttons provide one-click access to the most common tasks.',
      placement: 'bottom',
    },
    {
      id: 'lead-tabs',
      targetSelector: '[data-tour="lead-tabs"]',
      title: 'Lead Information Tabs',
      description:
        'Navigate between different sections: Details (personal info), Notes (your observations), History (calls, SMS, emails), Quotes (get insurance quotes via InsuraBot), and Documents (uploaded files).',
      placement: 'bottom',
    },
    {
      id: 'lead-details-section',
      targetSelector: '[data-tour="lead-details-section"]',
      title: 'Lead Details',
      description:
        'View and edit the lead\'s personal information including contact details, address, family information, income, and custom fields. Click "Edit" to make changes - they auto-save as you type.',
      placement: 'top',
    },
    {
      id: 'lead-policies',
      targetSelector: '[data-tour="lead-policies"]',
      title: 'Policy Information',
      description:
        'View and manage policies associated with this lead. Add new policies, track policy status, and see coverage details all in one place.',
      placement: 'left',
    },
    {
      id: 'lead-activity',
      targetSelector: '[data-tour="lead-activity"]',
      title: 'Activity Timeline',
      description:
        'Track all interactions and changes for this lead. See when calls were made, notes added, status changes, and more - giving you a complete history of your relationship with this prospect.',
      placement: 'left',
    },
  ],
};
